var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.to)?_c('div',{staticClass:"Row",class:{
    'Row-header' : _vm.header,
    'Row-body'   : !_vm.header
  }},[_vm._t("default")],2):_c('router-link',{staticClass:"Row clickable",class:{
    'Row-header' : _vm.header,
    'Row-body'   : !_vm.header
  },attrs:{"to":_vm.to}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }